export const uk = {
    adaptive: 'Адаптивний',
    create: 'Створити на основі'
};
